import React, { useEffect } from "react";
import './dashboard-cooler.css'
import { FaDropbox, FaExchangeAlt, FaHeartbeat, FaPlaneArrival, FaPlaneDeparture, FaRegLemon } from "react-icons/fa";

import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// --- PASO 1: REGISTRAR LOS MÓDULOS ---
// Esto es clave para que Chart.js y el plugin funcionen en React
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

// --- PASO 2: CREAMOS UN COMPONENTE REUTILIZABLE PARA LA GRÁFICA ---

const GraficaDona = ({ valores }) => {

  // Colores fijos (Naranja ocupado, Verde disponible)
  const colores = ['#F97F29', '#1CB07E'];

  const data = {
    datasets: [
      {
        data: valores, // Ej: [33.4, 66.6]
        backgroundColor: colores,
        borderColor: colores,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Para que se ajuste al div contenedor
    cutout: '50%', // El "agujero" de la dona
    plugins: {
      // Configuración del plugin de etiquetas
      datalabels: {
        display: true,
        formatter: (value) => {
          return value + '%'; // Agrega el símbolo %
        },
        color: '#fff', // Color del texto
        font: {
          weight: 'bold',
          size: 12,
        },
      },
      // Ocultamos la leyenda
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true, // Habilitar tooltips al pasar el mouse
      }
    },
  };

  return <Doughnut data={data} options={options} />;
};

const DashboardCooler = () => {
    // Definimos los datos de la imagen
    const datosTotal = [33.4, 66.6];
    const datosCam1 = [66.7, 33.3]; // Naranja 66.7%, Verde 33.3%
    const datosCam2 = [27.7, 72.3];
    const datosCam3 = [5.7, 94.3]; // 5.7% es el naranja (100 - 94.3)

    // 1. SIMULACIÓN DE DATOS (MOCK DATA)
    // Cuando tengas el back, estos datos vendrán por props o de un hook (useEffect).
    const data = {
        per: 1250, // Perecedero
        pha: 450,  // Pharma
        oth: 300,  // Otros
        imp: 800,  // Importación
        exp: 950,  // Exportación
        tra: 250,  // Tránsitos
        all: 4000  // Total (Denominador)
    };

    // 2. LÓGICA DE CÁLCULO
    // Replica: number_format(($per * 100 / $all), 2)
    const calculatePercentage = (value) => {
        // Evitamos división por cero si 'all' viene vacío
        if (!data.all || data.all === 0) return "0.00";
        
        const percentage = (value * 100) / data.all;
        return percentage.toFixed(2); // Esto hace lo mismo que number_format(x, 2)
    };

    return(
        <>
            <div className="container-fluid dashboard-cooler">
                <div className="row cooler-percentages">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-3 percentage-container tooltip-custom">
                                <FaRegLemon className="percentage-icon" />
                                <span className="percentage-text">
                                    {calculatePercentage(data.per)}%
                                </span>

                                <span className="tooltip-text">Perecedero</span>
                            </div>
                            <div className="col-3 percentage-container tooltip-custom">
                                <FaHeartbeat className="percentage-icon" />
                                <span>
                                    {calculatePercentage(data.pha)}%
                                </span>

                                <span className="tooltip-text">Pharma</span>
                            </div>
                            <div className="col-3 percentage-container tooltip-custom">
                                <FaDropbox className="percentage-icon" />
                                <span>
                                    {calculatePercentage(data.oth)}%
                                </span>

                                <span className="tooltip-text">Otros</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-3"></div>
                            <div className="col-3 percentage-container tooltip-custom">
                                <FaPlaneArrival className="percentage-icon" />
                                <span>
                                    {calculatePercentage(data.imp)}%
                                </span>

                                <span className="tooltip-text">Importación</span>
                            </div>
                            <div className="col-3 percentage-container tooltip-custom">
                                <FaPlaneDeparture className="percentage-icon" />
                                <span>
                                    {calculatePercentage(data.exp)}%
                                </span>

                                <span className="tooltip-text">Exportación</span>
                            </div>
                            <div className="col-3 percentage-container tooltip-custom">
                                <FaExchangeAlt className="percentage-icon" />
                                <span>
                                    {calculatePercentage(data.tra)}%
                                </span>

                                <span className="tooltip-text">Tránsitos</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row cooler-graphs mt-4">
                    <div className="col-3 cooler-graph border">
                        <h5>Espacio Total Cámaras</h5>
                        <div className="row">
                            <div className="col-6">
                                <p className="graph-title-2">Volumen Total</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                            <div className="col-6">
                                <p className="graph-title-2">Volumen Disponible</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                        </div>
                        {/* Contenedor de la gráfica */}
                        <div className="chart-container border" style={{ position: 'relative', height: '170px', width: '170px', margin: '1rem auto 2rem auto' }}>
                            <GraficaDona valores={datosTotal} />
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <p className="graph-title-2">Peso Ocupado</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                            <div className="col-6">
                                <p className="graph-title-2">Volumen Ocupado</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-3 cooler-graph">
                        <h5>Cámara 1</h5>
                        <div className="row">
                            <div className="col-6">
                                <p className="graph-title-2">Peso Ocupado</p>
                                <p className="graph-text-2">229.71 Kg</p>
                            </div>
                            <div className="col-6">
                                <p className="graph-title-2">Volumen Ocupado</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                        </div>
                        {/* Contenedor de la gráfica */}
                        <div className="chart-container border" style={{ position: 'relative', height: '170px', width: '170px', margin: '1rem auto 2rem auto' }}>
                            <GraficaDona valores={datosCam1} />
                        </div>
                        <div className="row">
                            <div class="status-grid">
                                <div class="cell">P1A - Ocup.</div>
                                <div class="cell disponible">P2A - Disp.</div>

                                <div class="cell">P1B - Ocup.</div>
                                <div class="cell">P2B - Ocup.</div>

                                <div class="cell">P1C - Ocup.</div>
                                <div class="cell">P2C - Ocup.</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-3 cooler-graph">
                        <h5>Cámara 2</h5>
                        <div className="row">
                            <div className="col-6">
                                <p className="graph-title-2">Peso Ocupado</p>
                                <p className="graph-text-2">229.71 Kg</p>
                            </div>
                            <div className="col-6">
                                <p className="graph-title-2">Volumen Ocupado</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                        </div>
                        {/* Contenedor de la gráfica */}
                        <div className="chart-container border" style={{ position: 'relative', height: '170px', width: '170px', margin: '1rem auto 2rem auto' }}>
                            <GraficaDona valores={datosCam2} />
                        </div>
                        <div className="row">
                            <div class="status-grid">
                                <div class="cell">P1A - Ocup.</div>
                                <div class="cell disponible">P2A - Disp.</div>

                                <div class="cell">P1B - Ocup.</div>
                                <div class="cell">P2B - Ocup.</div>

                                <div class="cell">P1C - Ocup.</div>
                                <div class="cell">P2C - Ocup.</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-3 cooler-graph">
                        <h5>Cámara 3</h5>
                        <div className="row">
                            <div className="col-6">
                                <p className="graph-title-2">Peso Ocupado</p>
                                <p className="graph-text-2">229.71 Kg</p>
                            </div>
                            <div className="col-6">
                                <p className="graph-title-2">Volumen Ocupado</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                        </div>
                        {/* Contenedor de la gráfica */}
                        <div className="chart-container border" style={{ position: 'relative', height: '170px', width: '170px', margin: '1rem auto 2rem auto' }}>
                            <GraficaDona valores={datosCam3} />
                        </div>
                        <div className="row">
                            <div class="status-grid">
                                <div class="cell">P1A - Ocup.</div>
                                <div class="cell disponible">P2A - Disp.</div>

                                <div class="cell">P1B - Ocup.</div>
                                <div class="cell">P2B - Ocup.</div>

                                <div class="cell">P1C - Ocup.</div>
                                <div class="cell">P2C - Ocup.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DashboardCooler;